import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { ThemeProvider } from "@academia-hub/ui";
import { AuthProvider } from "./auth/AuthProvider.js";
import { queryClient } from "./lib/query-client.js";
import { InstitutionProvider } from "./institution/institution-context.js";
import { router } from "./routes/routes.js";

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <InstitutionProvider>
            <RouterProvider router={router} />
          </InstitutionProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
